<nibtravel-snippet
  *contentful="
    ContentTypes.Alert;
    zone: zone;
    allowFallbackBrand: true;
    let data
  "
  [entry]="data"
>
</nibtravel-snippet>
